<template>
    <div id="app">
        <div id="main-info">
            <mt-cell title="切换用户" label="查看其它用户购票，点这里切换" :to="{path:'/personinfo',params:{'ticketid':'','ticketname':'','seatno':''}}" is-link></mt-cell>
        </div>

        <div id="mid-info">
            <ul v-for="item in list" :key="item.id" v-show="showinfo==false">
                <div class="infomainx">
                    <div class="infomainx-1">
                        <div class="info-img">        
                            <img class="img" :src="item.img" alt="Dynamic Image">
                        </div>
                    </div> 
                    <div class="infomainx-2">
                        <div class="ticketinfo-2" v-show!="showinfo">
                            <div id="ticket-info-name"> 
                                {{item.ticketname}} <br />
                            </div>
                            <div id="ticket-info-playtime"> 
                                时间
                            </div>
                            <div id="ticket-info-playtime-2"> 
                                {{item.playtime}}
                            </div>   

                            <div class="info-qr">
                                <div class="info-qr-1">
                                    <div id="ticket-info-officename"> 
                                        地点
                                    </div>
                                    <div id="ticket-info-officename-2"> 
                                        {{item.officename}}
                                    </div>
                                    <div id="ticket-info-seatnumber"> 
                                        座位
                                    </div>
                                    <div id="ticket-info-seatnumber-2"> 
                                        {{item.seatnumber}}
                                    </div>
                                </div>
                                <div class="info-qr-disp">
                                    <img class="img" :src="item.qrcode" alt="Dynamic Image">
                                    <!-- <div class="infoimg" :style="'background-image:url('+item.qrcode+');'">        
                                        
                                    </div> -->
                                    <!-- <div class="infoimg-2">        
                                        取票号：{{item.id}}-2
                                    </div> -->
                                </div>
                            </div>                             
                        </div>
                        
                    </div>                        
                </div>
            </ul>
        </div>

        <div id="bottom-info">
            <div class="tabbar" v-show!="showinfo">
                <mt-tabbar v-model="selected" fixed='fixed'>
                    <mt-tab-item id="ticketlist">
                        <img slot="icon" src="../assets/home.png">
                        首页
                    </mt-tab-item>
                    <mt-tab-item id="ownlist">
                        <img slot="icon" src="../assets/user.png">
                        我的
                    </mt-tab-item>
                </mt-tabbar>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios'
import qs from 'qs';
import { MessageBox } from 'mint-ui';

export default {
  name: 'main',
  data () {
    return {
      imageSrc: require('../assets/info.png'),
      msg: '这里是在线购票',  
      selected: 'electicketlist',
      showinfo:false,
      info:'',
      openid:'',   
      wxbaseinfo:{
        name:'',
        departmnet:'',
        serial:'',
        prenum:'',
        visittime:''
      },
      ticketname:'',
      playtime:'',
      officename:'',
      seatnumber:'',
      idnumber:'',
      username:'',
      seatno:'',
      list:[],
      link:'personinfo',
    }
  },
  watch: {
    selected: function(newV, oldV) {
      // mt-tab-item id
    //   console.log('newV',newV);
        //   console.log(this.selected);
      // this.$router.push({name: newV});
      // 编程导航 参数对应routes里面的命名name
      this.$router.push({name: this.selected});
    }
  },
  created(){      
    // 1、从缓存读取身份证号、姓名
    var temopenid = localStorage.getItem('idnumber');
    var temname = localStorage.getItem('username');
    // console.log(temopenid);
    // console.log(temname);
    if(temopenid!='undefined'){
        // 缓存存在
        this.idnumber=temopenid;
        this.username=temname;
        // 加载电子票二维码
        this.loadelecticketlist();
    }
    // 跳转到个人信息页

  },
  methods:{
    // 获取电子票信息
    loadelecticketlist(){
        var api='http://shzjapi.romis.cn:59848/api/getqrcode?idnumber=' + this.idnumber;
        Axios.get(api).then((response)=>{            
            if(response.data.result=='false'){
                // 无记录
                // this.$router.push({path:'/err'});
                this.info=response.data.errmsg;
                // this.showinfo=true;
            }
            else{
                // 解码用                 
                this.showinfo=false;         
                this.list=response.data.data;       
                // this.imageSrc=response.data.qrcode;
                // this.ticketname=response.data.ticketname;
                // this.officename=response.data.officename;
                // this.playtime=response.data.playtime;
                // this.seatnumber=response.data.seatnumber;
                console.log('this.list',this.list);       
            }
        }).catch((err)=>{
            alert('ticketlist获取票务列表失败：' + err);
        })
    }
  }
}
</script>

<style>

#app,/*设置占满*/
html,
body {
  background-color: #dbdbdb;
  width: 100%;
  height: 100%;
  margin: 0;
}
#app{
    display: -moz-box;
    display:-webkit-box;
    /* border:solid 1px red; */
    -moz-box-orient: vertical;
    -webkit-box-orient: vertical;
    width: 100%;    
    height: 100%;
}
#main-info,#mid-info,#bottom-info{
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
}
#main-info{
    width: 100%;
    height: 5%;
    /* background-color: blueviolet; */
}
#mid-info{
    width: 100%;
    height: auto;
    /* background-color: #f4f4f4; */
    /* background-color: blue; */
    /* display: flex; */
    padding: 5px;

    display: -moz-box;
    display:-webkit-box;
    -moz-box-orient: vertical;
    -webkit-box-orient: vertical;
}
#bottom-info{
    width: 100%;
    height: 5%;
    /* background-color:chartreuse;    */
}
.ticketinfo-2{
    width: 95%;
    height: 160px;
    display: -moz-box;
    display:-webkit-box;
    -moz-box-orient: vertical;
    -webkit-box-orient: vertical;
    /* background-color: red; */
    /* margin: 5px; */
}
.infomainx{
    width: 75%;
    height: 180px;
    background-color: rgb(255, 255, 255);
    border-radius: 10px; /* 设置所有四个边角为10px的圆角 */

    display: -moz-box;
    display:-webkit-box;
    /* border:solid 1px red; */
    -moz-box-orient: horizontal;
    -webkit-box-orient: horizontal;

    /* margin-left: 5px; */
}
.infomainx-1{
    width: 40%;
    height: 95%;
    /* background-color:red; */
    /* margin: 10px; */
    /* margin-top: 15px; */
    border-radius: 2px; /* 设置所有四个边角为10px的圆角 */
}
.infomainx-2{
    width: 50%;
    height: 90%;
    /* background-color:blue; */
    /* margin-top: 15px;
    margin-left: -5px; */

    display: -moz-box;
    display:-webkit-box;
    -moz-box-orient: vertical;
    -webkit-box-orient: vertical;
}
.dashed-line {
    border-top: 1px dashed #cccccc; /* 虚线的颜色和宽度 */
    width: 89%; /* 虚线的长度 */
    height: 1px;
    margin-top: 1px; /* 与其他元素的间距 */
    margin-left: 5px;
  }
.info-img{
    width: 100%;
    height: 90%;
    /* background-color:blueviolet; */
    border-radius: 2px; /* 设置所有四个边角为10px的圆角 */
}
.info-img img{
    width: 90%;
    height: 100%;
    margin:auto;
    display: block;
    object-fit:cover;
}
.info-qr{
    width: 100%;
    height: auto;
    /* background-color: rgb(198, 9, 223); */
    display: -moz-box;
    display:-webkit-box;
    -moz-box-orient: horizontal;
    -webkit-box-orient: horizontal;
}
.info-qr-disp{
    /* width: 70%; */
    display: -moz-box;
    display:-webkit-box;
    /* border:solid 1px red;
    -moz-box-orient: vertical;
    -webkit-box-orient: vertical; */
    justify-content: center; /* 水平居中 */
    align-items: center; /* 垂直居中 */
    /* height: 80px;  */
    background-color: red;
}
.info-qr-disp img{
    margin-left: 10px;
}
.infoimg{
    width: 60px;
    height: 60px;
    display: flex;
    /* justify-content: center; 
    align-items: center;  */

    box-shadow: 0px 3px 5px 2px #aaa;
    filter: opacity(60); 

    flex-direction: row/column;
    flex-wrap: nowrap/wrap;

    /* padding: 5px; */
}
.infoimg-2{
    font-size: 0.5em;
}
#ticket-info-name{
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  font-size: 1.5em;
  font-weight: bold;
  height: 30px;
}
#ticket-info-playtime,#ticket-info-officename,#ticket-info-seatnumber{
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  font-size: 0.6em;  
  height: 20px;
  color: grey;
}
#ticket-info-playtime-2,#ticket-info-officename-2,#ticket-info-seatnumber-2{
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  font-size: 0.8em;
  font-weight: bold;
  height: 20px;
}

</style>


// WEBPACK FOOTER //
// src/components/ownlist.vue